import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root")!;

// scripts/prerender.mjs bakes real markup into <div id="root"> for the
// routes it covers (see server/vite.ts), so the root has child nodes
// already; hydrate onto that instead of wiping it out with a fresh client
// render, or the prerendered content would flash and be replaced. Every
// other route still gets an empty root exactly as before, so this falls
// back to the original client-only render path unchanged.
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
